"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

interface MaterialsSurfaceFinishesProps {
	/** 材料卡片图片路径，可后续手动替换 */
	materialsImageSrc: string;
	/** 表面处理卡片图片路径，可后续手动替换 */
	surfaceFinishesImageSrc: string;
}

export default function MaterialsSurfaceFinishes({
	materialsImageSrc,
	surfaceFinishesImageSrc,
}: MaterialsSurfaceFinishesProps) {
	const t = useTranslations("precisionMachiningMaterialsFinishes");

	const cards = [
		{
			id: "materials",
			imageSrc: materialsImageSrc,
			linkUrl: "/materials/materials",
			buttonKey: "viewAllMaterials" as const,
		},
		{
			id: "surfaceFinishes",
			imageSrc: surfaceFinishesImageSrc,
			linkUrl: "/surface-finishing",
			buttonKey: "viewAllFinishes" as const,
		},
	] as const;

	return (
		<section className="bg-[#2d2d2d] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="flex flex-col gap-8 lg:flex-row lg:items-stretch lg:gap-10">
					{/* 左侧：深色背景 + 主标题 */}
					<div className="flex flex-shrink-0 lg:w-[320px] xl:w-[380px]">
						<h2 className="w-[80%] text-2xl font-bold leading-tight text-white sm:text-[30px] md:text-4xl">
							{t("sectionTitle")}
						</h2>
					</div>

					{/* 右侧：双卡片 */}
					<div className="grid min-w-0 flex-1 gap-6 sm:grid-cols-2">
						{cards.map((card) => (
							<div key={card.id} className="flex flex-col overflow-hidden rounded-sm bg-white">
								<div className="relative aspect-[4/2.2] w-full overflow-hidden bg-[#f5f6f8]">
									<Image
										src={card.imageSrc}
										alt={t(`${card.id}Subtitle`)}
										fill
										className="object-contain"
										sizes="(max-width: 640px) 100vw, 50vw"
									/>
								</div>
								<div className="flex flex-1 flex-col p-5 sm:p-6">
									<h3 className="mb-3 text-lg font-bold text-themePrimary400 sm:text-xl">
										{t(`${card.id}Subtitle`)}
									</h3>
									<p className="mb-6 flex-1 text-sm leading-relaxed text-black md:text-base">
										{t(`${card.id}Desc`)}
									</p>
									<a
										href={card.linkUrl}
										target="_blank"
										rel="noopener noreferrer"
										className="group inline-flex w-fit items-center justify-center gap-2 rounded bg-themePrimary400 px-4 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white sm:px-5 sm:py-3 sm:text-base"
									>
										{t(card.buttonKey)}
										<svg
											className="h-4 w-4 flex-shrink-0"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
											aria-hidden
										>
											<path
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth={2}
												d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
											/>
										</svg>
									</a>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
